import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export * from './common.style';

export const Footer = styled.div`
  position: relative;
  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: flex-end;

  padding: ${({ theme }) => theme.spacing(3)};

  background: ${({ theme }) => theme.palette.background.default};
  border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
`;

export const TooltipContent = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
`;

export const TooltipContentButton = styled.span<{ $wide?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: inline-flex;
  justify-content: center;
  align-items: center;

  width: ${({ $wide }) => ($wide ? '3.6rem' : '1.6rem')};
  height: 1.6rem;

  background: ${({ theme }) => rgba(theme.palette.common.white, 0.15)};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;
